module.exports = __webpack_public_path__ + "img/img-shipin-s6.f3a309c9.png";